import api from './api';

const productService = {
  // Récupérer tous les produits
  getProducts: async (params = {}) => {
    try {
      const response = await api.get('/products', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits:', error);
      throw error;
    }
  },

  // Récupérer un produit par ID
  getProduct: async (id) => {
    try {
      const response = await api.get(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du produit:', error);
      throw error;
    }
  },

  // Rechercher des produits
  searchProducts: async (query) => {
    try {
      const response = await api.get('/products', {
        params: { search: query }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la recherche des produits:', error);
      throw error;
    }
  },

  // Créer un produit
  createProduct: async (productData) => {
    try {
      const response = await api.post('/products', productData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du produit:', error);
      throw error;
    }
  },

  // Modifier un produit
  updateProduct: async (id, productData) => {
    try {
      const response = await api.put(`/products/${id}`, productData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la modification du produit:', error);
      throw error;
    }
  },

  // Supprimer un produit
  deleteProduct: async (id) => {
    try {
      const response = await api.delete(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression du produit:', error);
      throw error;
    }
  },

  // Upload d'images de produit (utilise multer)
  uploadProductImages: async (imageFiles) => {
    try {
      const formData = new FormData();
      imageFiles.forEach((file) => {
        formData.append('images', file);
      });
      
      const response = await api.post('/products/upload-images', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'upload des images:', error);
      throw error;
    }
  },

  // Supprimer une image de produit
  deleteProductImage: async (filename) => {
    try {
      const response = await api.delete(`/products/image/${filename}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'image:', error);
      throw error;
    }
  },

  // Récupérer les produits personnels de l'utilisateur (sans boutique)
  getMyProducts: async () => {
    try {
      const response = await api.get('/products/my-products', {
        params: { isActive: 'all' } // Récupérer tous les produits (actifs et inactifs)
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits personnels:', error);
      throw error;
    }
  },

  // Récupérer les produits de la boutique du vendeur (tous les produits, actifs et inactifs)
  getMyBoutiqueProducts: async (boutiqueId) => {
    try {
      const response = await api.get('/products/my-boutique-products', {
        params: { boutiqueId, isActive: 'all' } // Récupérer tous les produits (actifs et inactifs)
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits de la boutique:', error);
      throw error;
    }
  }
};

export { productService };